import { PlanBadge } from '../components/PlanBadge';
import type { License } from '../api/portalApi';
import styles from './Upgrade.module.css';

interface UpgradeProps {
  licenses: License[];
}

const PLANS = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: 'forever',
    features: ['1 plugin', '1 domain', 'Community support'],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$29',
    period: '/mo per plugin',
    features: ['Unlimited domains', 'Custom CSS', 'Priority support', 'Advanced analytics'],
    highlighted: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    features: ['All Pro features', 'Dedicated support', 'SLA guarantee', 'Custom integrations', 'On-premise option'],
  },
];

export function Upgrade({ licenses }: UpgradeProps) {
  const currentPlans = licenses.map((l) => l.plan);

  return (
    <div>
      <h1 className={styles.title}>Upgrade Your Plan</h1>
      <p className={styles.subtitle}>Choose the plan that fits your needs. Upgrade or downgrade anytime.</p>

      <div className={styles.planGrid}>
        {PLANS.map((plan) => {
          const isCurrent = currentPlans.includes(plan.id);
          return (
            <div
              key={plan.id}
              className={`${styles.planCard} ${plan.highlighted ? styles.highlighted : ''} ${isCurrent ? styles.current : ''}`}
            >
              {isCurrent && <span className={styles.currentBadge}>Current Plan</span>}
              <h3 className={styles.planName}>{plan.name}</h3>
              <div className={styles.planPrice}>
                <span className={styles.priceAmount}>{plan.price}</span>
                {plan.period && <span className={styles.pricePeriod}>{plan.period}</span>}
              </div>
              <ul className={styles.featureList}>
                {plan.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
              {plan.id === 'enterprise' ? (
                <a href="mailto:sales@chikchaklabs.com" className={styles.planBtn}>
                  Contact Sales
                </a>
              ) : isCurrent ? (
                <span className={styles.planBtnDisabled}>
                  <PlanBadge plan={plan.id} />
                </span>
              ) : (
                <span className={styles.planBtnSoon}>Coming Soon</span>
              )}
            </div>
          );
        })}
      </div>

      <div className={styles.note}>
        <strong>Need help choosing?</strong> Email us at{' '}
        <a href="mailto:sales@chikchaklabs.com">sales@chikchaklabs.com</a> and we'll help you find the right plan.
      </div>
    </div>
  );
}
